import { array, boolean, type ObjectSchema, string, object } from 'yup';

import { emailTypes } from '@/constants/memberContactInfo';
import type { Person } from '@/types/person';

export const emailsSchema: ObjectSchema<Pick<Person, 'emails'>> = object({
  emails: array()
    .of(
      object().shape({
        id: string().optional().label('Email id'),
        default: boolean().required().label('Default'),
        address: string().trim().email().required().label('Email address'),
        type: string().oneOf(emailTypes).required().label('Email type'),
        _delete: boolean().optional()
      })
    )
    .required()
    .test('atLeastOneRequired', 'At least one email is required', (emails) => {
      if (emails) {
        return !emails.every((email) => email._delete) && !!emails.length;
      }

      return true;
    })
    .test(
      'moreThanOneDefault',
      "You can't have more than one default email. Please uncheck one default.",
      (emails) => {
        if (emails) {
          return !(emails.filter((email) => email.default && !email._delete).length > 1);
        }

        return true;
      }
    )
});
